import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  SyntheticEvent,
  useEffect,
  useState,
} from "react";
import Typography from "@mui/material/Typography";
import { MastersProps } from "../Master/IMaster";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Divider from "@mui/material/Divider";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Container,
  SelectChangeEvent,
  SvgIcon,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import "./Pricing.scss";
import ButtonField from "../../Components/Button/ButtonField";
import { Add, Cancel, Delete, Edit } from "@mui/icons-material";
import IconButtonField from "../../Components/Button/IconButtonField";
import Dialog from "../../Components/Dialog/Dialog";
import TariffForm from "../Pricing/TariffForm";
import TarriffPricing from "../Pricing/TariffFormTime";
import { FormikProps } from "formik";
import { IPricingList } from "./IPricing";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import {
  clearDeletePricing,
  deletePricing,
} from "../../Redux/Slicers/Pricing/DeletePricingSlice";
import { getPricing } from "../../Redux/Slicers/Pricing/PricingSlicer";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import { clearUpdateableData } from "../../Redux/Slicers/Master/UpdateMasterSlicer";
import { clearAddPricingState } from "../../Redux/Slicers/Pricing/AddPricingSlicer";
import {
  clearUpdatePricingState,
  PricingUpdateableData,
  updatePricing,
} from "../../Redux/Slicers/Pricing/UpdatePricingSlicer";
import {
  addDayOfWeek,
  clearAddDayOfWeekState,
} from "../../Redux/Slicers/DayOfWeek/AddDayOfWeekSlicer";
import { getDayOfWeek } from "../../Redux/Slicers/DayOfWeek/DayOfWeekSlicer";
import SpecialDayForm from "./SpecialDayForm";
import { getSpecialDay } from "../../Redux/Slicers/SpecialDay/SpecialDaySlicer";
import { clearAddSpecialDayState } from "../../Redux/Slicers/SpecialDay/AddSpecialDaySlicer";
import {
  clearUpdateSpecialDayState,
  SpecialDaysUpdateableData,
} from "../../Redux/Slicers/SpecialDay/UpdateSpecialDaySlicer";
import { date } from "yup";
import dayjs from "dayjs";
import { deleteSpecialDay } from "../../Redux/Slicers/SpecialDay/DeleteSpecialDaySlice";
import { getOneLocation } from "../../Redux/Slicers/Location/GetOneLocationSlicer copy";
import {
  clearUpdateLocationState,
  updateLocation,
} from "../../Redux/Slicers/Location/UpdateLocationSlicer";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  // borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

interface MasterFormProps {
  vehicleForm: (data: FormikProps<any>) => void;
}

const Pricing: FunctionComponent<MastersProps> = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { pathname } = location;
  const pathnameParts = location.pathname.split("/");
  const id = pathnameParts[pathnameParts.length - 1];
  const [formik, setFormik] = useState<FormikProps<any>>();
  const [open1, setOpen1] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const [editData, setEditData] = useState<any>();

  const [pricingData, setPricingData] = useState<Array<any>>([]);
  const [age, setAge] = useState("");
  const [open, setOpen] = useState(false);
  const [pricingOpen, setPricingOpen] = useState(false);

  const [deleteOpen1, setDeleteOpen1] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteStructureOpen, setDeleteStructureOpen] =
    useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>("");
  const [deleteablePricing, setDeleteablePricing] = useState<any>("");
  const [deleteStructureId, setDeleteStructureId] = useState<string>("");
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [openBillingDialog, setOpenBillingDialog] = useState(false);
  const [billingSettings, setBillingSettings] = useState({
    minimum_billing_time_unit: "",
    grace_time: "",
  });
  const { data: getdayOfWeek } = useAppSelector((state) => state?.DayOfWeek);
  const dayofwe: any = getdayOfWeek?.response?.data;

  const [selectedPrices, setSelectedPrices] = useState<any>({
    Sunday: dayofwe ? dayofwe?.sun?._id : "",
    Monday: dayofwe ? dayofwe?.mon?._id : "",
    Tuesday: dayofwe ? dayofwe?.tue?._id : "",
    Wednesday: dayofwe ? dayofwe?.wed?._id : "",
    Thursday: dayofwe ? dayofwe?.thu?._id : "",
    Friday: dayofwe ? dayofwe?.fri?._id : "",
    Saturday: dayofwe ? dayofwe?.sat?._id : "",
  });
  console.log("selected", selectedPrices);

  useEffect(() => {
    if (dayofwe) {
      setSelectedPrices({
        Sunday: dayofwe.sun?._id || "",
        Monday: dayofwe.mon?._id || "",
        Tuesday: dayofwe.tue?._id || "",
        Wednesday: dayofwe.wed?._id || "",
        Thursday: dayofwe.thu?._id || "",
        Friday: dayofwe.fri?._id || "",
        Saturday: dayofwe.sat?._id || "",
      });
    }
  }, [dayofwe]);
  const { data: updateOwner, updateableDate } = useAppSelector(
    (state) => state?.UpdatePricing
  );
  const { data: addSpecial } = useAppSelector((state) => state?.AddSpecialDay);
  const { data: updateSpecialDay, updateableDates } = useAppSelector(
    (state) => state?.UpdateSpecialDay
  );

  const { data: addOwner } = useAppSelector((state) => state?.AddPricing);
  const { data: deleteOwnerData } = useAppSelector(
    (state) => state?.DeletePricing
  );
  const { data: deleteSpecialData } = useAppSelector(
    (state) => state?.DeleteSpecialDay
  );
  const { data: addayOfWeek } = useAppSelector((state) => state?.AddDayOfWeek);

  const { data: getdata } = useAppSelector((state) => state?.Pricing);
  const { data: getspecial } = useAppSelector((state) => state?.SpecialDay);
  const { data: updateLocationData } = useAppSelector(
    (state) => state?.UpdateLocation
  );
  const { data: getOneLocationData } = useAppSelector(
    (state) => state?.GetOneLocation
  );
  const locationData = getOneLocationData?.response?.data as
    | {
        minimum_billing_time_unit?: string;
        grace_time?: string;
      }
    | undefined;

  const isUpdateable =
    updateableDate && Object.keys(updateableDate)?.length !== 0;

  const isUpdateables =
    updateableDates && Object.keys(updateableDates)?.length !== 0;

  console.log(isUpdateables);

  const rows: any = getdata?.response?.data;
  console.log("rows", rows);

  const rowspecial: any[] = getspecial?.response?.data || [];

  useEffect(() => {
    dispatch(getPricing(id));
  }, [updateOwner, addOwner, deleteOwnerData]);

  useEffect(() => {
    if (id) {
      dispatch(getOneLocation(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    setBillingSettings({
      minimum_billing_time_unit: locationData?.minimum_billing_time_unit || "",
      grace_time: locationData?.grace_time || "",
    });
  }, [locationData?.minimum_billing_time_unit, locationData?.grace_time]);

  useEffect(() => {
    const isUpdated =
      updateLocationData?.responseMessage === "success" ||
      updateLocationData?.responseCode === 200 ||
      updateLocationData?.response?.status === true;

    if (isUpdated && id) {
      dispatch(getOneLocation(id));
    }
  }, [updateLocationData, dispatch, id]);

  useEffect(() => {
    dispatch(getDayOfWeek(id));
  }, []);

  useEffect(() => {
    dispatch(getSpecialDay(id));
  }, [addSpecial, deleteSpecialData, updateSpecialDay]);
  // useEffect(() => {

  useEffect(() => {
    console.log("getdayOfWeek", getdayOfWeek);
  }, [getdayOfWeek]);
  const [expanded, setExpanded] = useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const handleSelectChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };

  const handleDialogClose = () => {
    setOpen(false);
    setOpen1(false);
    setPricingOpen(false);
    setDeleteStructureOpen(false);
    setDeleteStructureId("");

    dispatch(clearUpdatePricingState());
    dispatch(clearAddSpecialDayState());
    dispatch(clearUpdateSpecialDayState());
    dispatch(clearUpdateableData());
  };

  const handlePricingStructureDelete = (
    event: MouseEvent<HTMLButtonElement>,
    structure: any
  ) => {
    event.stopPropagation();
    event.preventDefault();
    setDeleteableName(structure?.name || "");
    setDeleteStructureId(structure?._id || "");
    setDeleteStructureOpen(true);
  };

  const handlePricingStructureEdit = (
    event: MouseEvent<HTMLButtonElement>,
    structure: any
  ) => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(PricingUpdateableData(structure));
    setOpen(true);
  };

  const masterForm = (data: FormikProps<IPricingList>) => {
    setFormik(data);
  };
  useEffect(() => {
    return () => {
      dispatch(clearAddPricingState());
      dispatch(clearUpdateableData());
      dispatch(clearDeletePricing());
      dispatch(clearUpdatePricingState());
      dispatch(clearAddDayOfWeekState());
      dispatch(clearAddSpecialDayState());
      dispatch(clearUpdateSpecialDayState());
      dispatch(clearUpdateLocationState());
    };
  }, []);
  const handleSelectChangee = (day: string) => (event: SelectChangeEvent) => {
    setSelectedPrices({
      ...selectedPrices,
      [day]: event.target.value as string,
    });
  };

  const handleSave = () => {
    dispatch(addDayOfWeek({ ...selectedPrices, location_id: id }));
  };

  const handleBillingSettingsSave = () => {
    dispatch(
      updateLocation({
        billing_settings_only: true,
        location_id: id,
        minimum_billing_time_unit:
          billingSettings.minimum_billing_time_unit,
        grace_time: billingSettings.grace_time,
      } as any)
    );
  };

  return (
    <>
      <div className="container header_container">
        <div className="headings_container">
          <p className="heading">Pricing</p>
          <div className="pricing_meta_container">
            <ButtonField
              className="add_button"
              onClick={() => setOpenBillingDialog(true)}
            >
              BILLING SETTINGS
            </ButtonField>
          </div>
        </div>
        <Divider />

        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography>Pricing Structure</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ButtonField
              sx={{ float: "right" }}
              className="add_button"
              onClick={() => {
                setOpen(true); // Open the dialog
                dispatch(clearUpdateableData());
                dispatch(clearUpdatePricingState());
              }}
            >
              <SvgIcon component={Add} inheritViewBox />
              Add New
            </ButtonField>

            <AccordionDetails sx={{ marginTop: "30px" }}>
              {rows?.map((row: any, index: any) => (
                <Accordion key={index}>
                  <AccordionSummary
                    sx={{
                      marginTop: "10px",
                      "& .MuiAccordionSummary-content": {
                        alignItems: "center",
                        justifyContent: "space-between",
                      },
                    }}
                    aria-controls={`area-${index}-content`}
                    id={`area-${index}-header`}
                  >
                    <Typography>{row.name}</Typography>
                    <div>
                      <IconButtonField
                        onClick={(event) =>
                          handlePricingStructureEdit(event, row)
                        }
                        aria-label="edit pricing structure"
                        sx={{ mr: 1 }}
                      >
                        <Edit className="action_icons" />
                      </IconButtonField>
                      <IconButtonField
                        onClick={(event) =>
                          handlePricingStructureDelete(event, row)
                        }
                        aria-label="delete pricing structure"
                      >
                        <Delete className="action_icons" />
                      </IconButtonField>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <ButtonField
                      sx={{ float: "right" }}
                      className="add_button"
                      onClick={() => {
                        setSelectedRowId(row._id);
                        setPricingOpen(true); // Open the dialog
                        dispatch(clearUpdateableData());
                        dispatch(clearUpdatePricingState());
                        // dispatch(updatePricing(row._id));
                      }}
                    >
                      <SvgIcon component={Add} inheritViewBox />
                      Add New
                    </ButtonField>
                    <TableContainer component={Paper} sx={{ mt: "10px" }}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="tableHead" rowSpan={2}>
                              Name
                            </TableCell>
                            <TableCell
                              className="tableHead"
                              rowSpan={2}
                              align="center"
                            >
                              Day Time Hours
                            </TableCell>

                            <TableCell className="tableHead" align="center">
                              Unit Rate
                            </TableCell>
                            <TableCell className="tableHead" align="center">
                              Daytime Cap
                            </TableCell>
                            <TableCell className="tableHead" align="center">
                              Night Time Cap
                            </TableCell>

                            <TableCell className="tableHead" align="center">
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {row.area?.map((area: any) => (
                            <TableRow
                              key={area?.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell component="th" scope="row">
                                <span>
                                  {area?.name}
                                  <span
                                    style={{
                                      background: "green",
                                      fontWeight: "bold",
                                      color: "white",
                                      padding: "2px 5px",
                                      marginLeft: "8px",
                                      borderRadius: "4px",
                                      display: "inline-block"
                                    }}
                                  >
                                    {area?.space_type_id?.name}
                                  </span>
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                {area?.dayTimeStart?.length > 7
                                  ? `${format(
                                      new Date(row?.dayTimeStart),
                                      "hh:mm a"
                                    )}`
                                  : `${format(
                                      new Date(
                                        `1970-01-01T${row?.dayTimeStart}`
                                      ),
                                      "hh:mm a"
                                    )}`}
                                {" - "}
                                {area?.dayTimeEnd?.length > 7
                                  ? `${format(
                                      new Date(row?.dayTimeEnd),
                                      "hh:mm a"
                                    )}`
                                  : `${format(
                                      new Date(
                                        `1970-01-01T${row?.dayTimeEnd}`
                                      ),
                                      "hh:mm a"
                                    )}`}
                              </TableCell>
                              <TableCell align="center">
                                {area?.hourlyRate}
                              </TableCell>
                              <TableCell align="center">
                                {area?.dayTimeCap}
                              </TableCell>
                              <TableCell align="center">
                                {area?.nightTimeCap}
                              </TableCell>

                              <TableCell align="center">
                                {/* style={{ display: "flex" }}> */}
                                <IconButtonField
                                  onClick={() => {
                                    setSelectedRowId(row._id);
                                    setPricingOpen(true); // Open the dialog                                    // dispatch(PricingUpdateableData(area));
                                    dispatch(PricingUpdateableData(area));
                                    setEditData(area); // Assuming `setEditData` is used to set the data for editing
                                    // setEditOpen(true); // Assuming `setEditOpen` controls the visibility of the edit dialog
                                  }}
                                  aria-label="edit"
                                >
                                  <Edit className="action_icons" />
                                </IconButtonField>
                                <IconButtonField
                                  onClick={() => {
                                    console.log("row?._id", row?._id, area._id);

                                    setDeleteableName(area?.name);
                                    setDeleteablePricing({
                                      id: row?._id,
                                      areaId: area?._id,
                                    });
                                    setDeleteOpen(true);
                                  }}
                                  aria-label="delete"
                                >
                                  <Delete className="action_icons" />
                                </IconButtonField>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              ))}
            </AccordionDetails>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
            <Typography>Price Config for day</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Container>
              <Grid container spacing={2}>
                {Object.keys(selectedPrices)?.map((day) => (
                  <Grid
                    sx={{ display: "flex" }}
                    item
                    xs={12}
                    // sm={6}
                    md={10}
                    key={day}
                  >
                    <Typography
                      sx={{
                        alignContent: "center",
                        textAlign: "left",
                        width: "200px",
                      }}
                    >
                      {day}
                    </Typography>
                    <FormControl sx={{ width: "400px" }}>
                      <InputLabel id={`select-${day}-label`}>
                        {day} Price
                      </InputLabel>
                      <Select
                        labelId={`select-${day}-label`}
                        id={`select-${day}`}
                        value={selectedPrices[day]}
                        label={day + ` Price`}
                        onChange={handleSelectChangee(day)}
                      >
                        {rows?.map((row: any) => (
                          <MenuItem key={row?._id} value={row?._id}>
                            {row?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                ))}
              </Grid>
              <ButtonField
                sx={{ marginLeft: "50%", top: "10px" }}
                className="add_button"
                onClick={handleSave}
              >
                Attach
              </ButtonField>
            </Container>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
            <Typography>Special Day</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ButtonField
              sx={{ float: "right" }}
              className="add_button"
              onClick={() => setOpen1(true)}
            >
              <SvgIcon component={Add} inheritViewBox />
              Add New
            </ButtonField>
            <TableContainer component={Paper} sx={{ mt: "10px" }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className="tableHead" rowSpan={2}>
                      Name
                    </TableCell>
                    <TableCell className="tableHead" rowSpan={2}>
                      Date
                    </TableCell>
                    <TableCell className="tableHead" rowSpan={2}>
                      Price Structure
                    </TableCell>
                    <TableCell className="tableHead" align="center">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(rowspecial) ? (
                    rowspecial.map((special: any) => (
                      <TableRow
                        key={special?.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {special?.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {dayjs(special?.date).format("YYYY-MM-DD")}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {special?.price_structure?.name}{" "}
                        </TableCell>
                        <TableCell align="center" style={{ display: "flex" }}>
                          <IconButtonField
                            onClick={() => {
                              setOpen1(true);
                              dispatch(SpecialDaysUpdateableData(special));

                              // setEditData(row); // Assuming `setEditData` is used to set the data for editing
                              // setEditOpen(true); // Assuming `setEditOpen` controls the visibility of the edit dialog
                            }}
                            aria-label="edit"
                          >
                            <Edit className="action_icons" />
                          </IconButtonField>
                          <IconButtonField
                            onClick={() => {
                              setDeleteableName(special?.name);
                              setDeleteableId(special?._id);
                              setDeleteOpen1(true);
                            }}
                            aria-label="delete"
                          >
                            <Delete className="action_icons" />
                          </IconButtonField>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4}>No data available</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
        {/* page end */}
        {/* add tariff dialog */}
        <Dialog
          open={open}
          dialogClassName="add_tariff_dialog"
          dialogTitleClassName="master_dialog_title"
          // maxWidth={false}
          // fullScreen={screenSize}
          Dialog_Title={
            <>
              {isUpdateable ? "Edit" : "Add New"}
              <IconButtonField onClick={handleDialogClose}>
                <SvgIcon component={Cancel} inheritViewBox />
              </IconButtonField>
            </>
          }
          Dialog_Content={<TariffForm TariffFrom={masterForm} />}
          dialogActionClassName="master_dialog_action"
          // Dialog_Actions={
          //   <ButtonField
          //     sx={{ marginRight: "123px !important" }}
          //     className="cancel_button"
          //     onClick={handleDialogClose}>
          //     Cancel
          //   </ButtonField>
          // }
        />

        <Dialog
          open={open1}
          dialogClassName="add_tariff_dialog"
          dialogTitleClassName="master_dialog_title"
          // maxWidth={false}
          // fullScreen={screenSize}
          Dialog_Title={
            <>
              {isUpdateables ? "Edit" : "Add New"}
              <IconButtonField onClick={handleDialogClose}>
                <SvgIcon component={Cancel} inheritViewBox />
              </IconButtonField>
            </>
          }
          Dialog_Content={
            <SpecialDayForm masterForm={masterForm} rows={rows} />
          }
          dialogActionClassName="master_dialog_action"
          Dialog_Actions={
            <Grid container justifyContent="center" spacing={2}>
              <Grid item>
                <ButtonField
                  className="cancel_button"
                  onClick={handleDialogClose}
                >
                  Cancel
                </ButtonField>
              </Grid>
              <Grid item>
                <ButtonField
                  className="add_button"
                  onClick={() => {
                    formik?.handleSubmit();
                  }}
                >
                  {isUpdateables ? "Update" : "Save"}
                </ButtonField>
              </Grid>
            </Grid>
          }
        />

        <ResponseDialog response={addOwner} parentDialog={setOpen} />
        <ResponseDialog response={addayOfWeek} parentDialog={setOpen} />
        <ResponseDialog response={updateOwner} parentDialog={setOpen} />
        <ResponseDialog
          response={updateLocationData}
          parentDialog={setOpenBillingDialog}
        />

        <ResponseDialog response={updateOwner} parentDialog={setPricingOpen} />
        <ResponseDialog response={addSpecial} parentDialog={setOpen1} />

        <ResponseDialog response={updateSpecialDay} parentDialog={setOpen1} />

        <DeleteDialog
          deleteableName={deleteableName}
          open={deleteStructureOpen}
          setOpen={setDeleteStructureOpen}
          deleteFunction={() => {
            if (deleteStructureId) {
              dispatch(deletePricing(deleteStructureId));
            }
          }}
          response={deleteOwnerData}
        />

        <DeleteDialog
          deleteableName={deleteableName}
          open={deleteOpen}
          setOpen={setDeleteOpen}
          deleteFunction={() => {
            dispatch(
              updatePricing({
                _id: deleteablePricing.id,
                deleteAreaId: deleteablePricing.areaId,
              })
            );
          }}
          response={updateOwner}
        />

        <DeleteDialog
          deleteableName={deleteableName}
          open={deleteOpen1}
          setOpen={setDeleteOpen1}
          deleteFunction={() => dispatch(deleteSpecialDay(deleteableId))}
          response={deleteSpecialData}
        />

        <Dialog
          open={pricingOpen}
          dialogClassName="add_tariff_dialog"
          dialogTitleClassName="master_dialog_title"
          // maxWidth={false}
          // fullScreen={screenSize}
          Dialog_Title={
            <>
              {isUpdateable ? "Edit" : "Add New"}
              <IconButtonField onClick={handleDialogClose}>
                <SvgIcon component={Cancel} inheritViewBox />
              </IconButtonField>
            </>
          }
          Dialog_Content={
            <TarriffPricing
              TariffFrom={masterForm}
              rowId={selectedRowId}
              initialValues={editData} // pre-fill with edit data
            />
          }
          dialogActionClassName="master_dialog_action"
          // Dialog_Actions={
          //   <>
          //     <ButtonField
          //       sx={{ marginRight: "123px !important" }}
          //       className="cancel_button"
          //       onClick={handleDialogClose}>
          //       Cancel
          //     </ButtonField>
          //   </>
          // }
        />

        <Dialog
          open={openBillingDialog}
          dialogClassName="add_tariff_dialog"
          dialogTitleClassName="master_dialog_title"
          Dialog_Title={
            <>
              Update Billing Settings
              <IconButtonField onClick={() => setOpenBillingDialog(false)}>
                <SvgIcon component={Cancel} inheritViewBox />
              </IconButtonField>
            </>
          }
          Dialog_Content={
            <Grid container spacing={2} sx={{ paddingTop: 1 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Minimum Billing Time"
                  value={billingSettings.minimum_billing_time_unit}
                  onChange={(e) =>
                    setBillingSettings((prev) => ({
                      ...prev,
                      minimum_billing_time_unit: e.target.value,
                    }))
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Grace Time"
                  value={billingSettings.grace_time}
                  onChange={(e) =>
                    setBillingSettings((prev) => ({
                      ...prev,
                      grace_time: e.target.value,
                    }))
                  }
                />
              </Grid>
            </Grid>
          }
          dialogActionClassName="master_dialog_action"
          Dialog_Actions={
            <Grid container justifyContent="center" spacing={2}>
              <Grid item>
                <ButtonField
                  className="cancel_button"
                  onClick={() => setOpenBillingDialog(false)}
                >
                  Cancel
                </ButtonField>
              </Grid>
              <Grid item>
                <ButtonField
                  className="add_button"
                  onClick={handleBillingSettingsSave}
                >
                  Update
                </ButtonField>
              </Grid>
            </Grid>
          }
        />
      </div>
    </>
  );
};

export default Pricing;
